<nav mat-tab-nav-bar class="mc-arrow-tabs" [tabPanel]="tabPanel">
  <a mat-tab-link [routerLink]="routerLinkCommand$ | async">
    <img class="mc-flare-online-link-logo" alt="Flare Online Logo" src="assets/images/madcap-flare-online-text-logo-white.svg">
  </a>
</nav>
<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>